import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';

import { ClientUserService } from '../../../services';
import { FavoritesService } from '../../../services/favorites/favorites.service';
import { IconButtonComponent } from '../icon-button/icon-button.component';

@Component({
    selector: 'lib-favorite-button',
    standalone: true,
    imports: [CommonModule, IconButtonComponent],
    templateUrl: './favorite-button.component.html',
    styleUrl: './favorite-button.component.scss'
})
export class FavoriteButtonComponent implements OnInit {
    /* eslint-disable */
    clientUserService = inject(ClientUserService);

    @Input() color: string = 'var(--ion-color-primary)';
    @Input() borderColor: string = 'var(--ion-color-dark-60)';
    @Input() isFavorite: boolean = false;
    @Input() proId: string | number | undefined;
    @Input() favoriteProOnClick: boolean = true;
    @Input() autoInitFavoriteState: boolean = true;

    @Output() onClickEvent: EventEmitter<any> = new EventEmitter<any>();

    constructor(private favoritesService: FavoritesService) {}

    ngOnInit(): void {
        if (this.autoInitFavoriteState) {
            this.setIsFavorite();
        }
    }

    favoriteButtonClick(event: Event) {
        event.stopPropagation();
    }

    setIsFavorite() {
        this.isFavorite = this.favoritesService.isItFave(this.proId) || false;
    }

    onButtonClick() {
        this.onClickEvent.emit();
        if (this.favoriteProOnClick) {
            this.favoritePro(this.proId);
        }
    }

    favoritePro(id: string | number | undefined) {
        if (id === undefined) return;
        this.isFavorite = this.favoritesService.clickFave(Number(id), this.isFavorite);
    }
}
